import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'
import { getToken } from '@/plugins/auth' // getToken from cookie

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes
})

const whiteList = ['/login']// no redirect whitelist

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title + ' - ' + Config.title
    }
    if (getToken()) {
        // 已登录且要跳转的页面是登录页
        if (to.path === '/login') {
            next({ path: '/' })
        } else {
            store.dispatch('GetInfo').then(() => { // 拉取user_info
                next()
            }).catch(() => {
                store.dispatch('LogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            })
        }
    } else {
        /* has no token*/
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
        } else {
            next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
        }
    }
})

export default router
